<template>
	<v-layout row wrap>

		<v-flex class="mb-4" xs12 >
			<h1 class="title mb-2">My Voucher - Payroll Period 05/01/2019 to 05/15/2019</h1>
			<div style="min-height:400px;">
				<v-layout row>
					<v-flex sm6 xs6>
						<v-card class="mb-3 mr-3" >
							<v-toolbar card class="blue dark-3">
								<span class="headline white--text">EARNINGS</span>
							</v-toolbar>
							<v-layout row>
								<v-flex xs6>
									<v-card-title>
										<div>
											<span class=" black--text">Basic Pay</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">13th Month</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">Overtime Pay</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">Adjustments</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">Allowances</span>
										</div>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-title>
										<div>
											<span class="title black--text">Total Earnings</span>
										</div>
									</v-card-title>
								</v-flex>
								<v-flex xs6>
									<v-card-text>
										<div>
											<span class="text-lg-right black--text">15,000.00</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class="text-lg-right black--text">30,000.00</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class="text-lg-right black--text">6,250.00</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class="text-lg-right black--text">00.00</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class="text-lg-right black--text">2,500.00</span>
										</div>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-text>
										<div>
											<span class="title  text-lg-right black--text">53,750.00</span>
										</div>
									</v-card-text>
								</v-flex>
							</v-layout>
								
						</v-card>
					</v-flex>
					<v-flex xs6>
						<v-card class="mb-3 mr-3" >
							<v-toolbar card class="blue dark-3">
								<span class="headline white--text">DEDUCTIONS</span>
							</v-toolbar>
							<v-layout row>
							<v-flex xs6>
								<v-card-title>
									<div>
										<span class="text-lg-left left black--text">Undertime/Tardy</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left black--text">SSS Prem.</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left black--text">PhilHealth Prem.</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left black--text">HDMF Prem.</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left black--text">Tax Withheld</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left black--text">HMO</span>
									</div>
								</v-card-title>
								<v-card-title>
									<div>
										<span class="text-lg-left  black--text">CANTEEN BREWED</span>
									</div>
								</v-card-title>
								<v-divider></v-divider>
								<v-card-title>
									<div>
										<span class="title text-lg-left  black--text">Total Deductions</span>
									</div>
								</v-card-title>
							</v-flex>
							<v-flex xs6>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">00.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">140.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">200.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">100.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">1,750.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">160.00</span>
									</div>
								</v-card-text>
								<v-card-text>
									<div>
										<span class="text-lg-right  black--text">1,800.00</span>
									</div>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-text>
									<div>
										<span class="title text-lg-right black--text">4,150.00</span>
									</div>
								</v-card-text>
							</v-flex>
						</v-layout>
								
						</v-card>
					</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs6>
						<v-card class="mb-3 mr-3" >
							<v-toolbar card class="blue dark-3">
								<span class="headline white--text">BALANCES</span>
							</v-toolbar>
							<v-layout row>
								<v-flex xs6>
									<v-card-title>
										<div>
											<span class=" black--text">HMO</span>
										</div>
									</v-card-title>
								</v-flex>
								<v-flex xs6>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">792.00</span>
										</div>
									</v-card-text>
								</v-flex>
							</v-layout>
						</v-card>
					</v-flex>
					<v-flex xs6>
						<v-card class="mb-3 mr-3">
							<v-toolbar card class="blue dark-3">
								<span class="headline white--text">YTD SUMMARY</span>
							</v-toolbar>
							<v-layout row>
								<v-flex xs6>
									<v-card-title>
										<div>
											<span class=" black--text">Net Tax Earnings</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">Tax Withheld</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">Philhealth Prem.</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">SSS Prem.</span>
										</div>
									</v-card-title>
									<v-card-title>
										<div>
											<span class=" black--text">HDMF Prem.</span>
										</div>
									</v-card-title>
								</v-flex>
								<v-flex xs6>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">XXX,XXXX.XX</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">XXX,XXXX.XX</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">XXX,XXXX.XX</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">XXX,XXXX.XX</span>
										</div>
									</v-card-text>
									<v-card-text>
										<div>
											<span class=" text-lg-right black--text">XXX,XXXX.XX</span>
										</div>
									</v-card-text>
								</v-flex>
							</v-layout>
						</v-card>
					</v-flex>
				</v-layout>
				
				<v-card class="mb-3 mr-3" >
					<v-flex xs12>
						<v-toolbar card class="blue dark-3">
							<span class="headline white--text">NET PAY</span>
							<v-spacer></v-spacer>
							<span class="title white--text text-lg-center">49,600.00</span>
						</v-toolbar>
					</v-flex>
				</v-card>
			</div>
		</v-flex>
		
	</v-layout>
</template>

<script>
	import VueCookies from 'vue-cookies';
	import axios from 'axios';

	export default {
		data () {
			return {

			}
		}
	}
</script>

<style scoped>
	.text-right {
		text-align: right;
	}
    .custom-loader {
	    animation: loader 1s infinite;
	    display: flex;
	}
	@-moz-keyframes loader {
	    from {
	      transform: rotate(0);
	    }
	    to {
	      transform: rotate(360deg);
	    }
	}
	@-webkit-keyframes loader {
	    from {
	      transform: rotate(0);
	    }
	    to {
	      transform: rotate(360deg);
	    }
	}
	@-o-keyframes loader {
	    from {
	      transform: rotate(0);
	    }
	    to {
	      transform: rotate(360deg);
	    }
	}
	@keyframes loader {
	    from {
	      transform: rotate(0);
	    }
	    to {
	      transform: rotate(360deg);
	    }
	}
</style>